import { render, staticRenderFns } from "./EmailConfirmBlock.vue?vue&type=template&id=f5c94772&scoped=true&"
import script from "./EmailConfirmBlock.vue?vue&type=script&lang=ts&"
export * from "./EmailConfirmBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c94772",
  null
  
)

export default component.exports